// One-tap AOI presets. Rectangle coords are rings in [lon,lat] closed.
import { polygonAreaKm2 } from "@/lib/geo";

const makeRect = (w, s, e, n) => [
  [w, s],
  [e, s],
  [e, n],
  [w, n],
  [w, s],
];

// Rough polygonal approximations good enough for a preview quote.
export const AOI_PRESETS = [
  {
    key: "western-ghats",
    name: "Western Ghats",
    sub: "Konkan → Nilgiris corridor",
    rotation: [-78, -16],
    coords: [
      [72.9, 20.8],
      [73.5, 20.5],
      [74.1, 19.0],
      [74.4, 17.5],
      [74.9, 15.5],
      [75.6, 13.5],
      [76.4, 12.0],
      [77.0, 10.8],
      [77.4, 9.5],
      [77.0, 8.4],
      [76.5, 8.6],
      [76.2, 10.0],
      [75.5, 11.5],
      [74.8, 13.5],
      [74.1, 15.5],
      [73.4, 17.0],
      [73.0, 18.5],
      [72.7, 20.5],
      [72.9, 20.8],
    ],
  },
  {
    key: "sundarbans",
    name: "Sundarbans",
    sub: "Ganges Brahmaputra delta mangroves",
    rotation: [-89, -22],
    coords: [
      [88.1, 22.5],
      [88.9, 22.5],
      [89.6, 22.2],
      [89.9, 21.8],
      [89.6, 21.5],
      [88.9, 21.5],
      [88.1, 21.6],
      [88.0, 22.0],
      [88.1, 22.5],
    ],
  },
  {
    key: "ne-india",
    name: "NE India",
    sub: "Assam, Meghalaya, Arunachal forests",
    rotation: [-93, -26],
    coords: makeRect(89.5, 24.0, 96.5, 29.2),
  },
];

export function presetToAoi(preset) {
  const ring =
    preset.coords[0] === preset.coords[preset.coords.length - 1]
      ? preset.coords
      : [...preset.coords, preset.coords[0]];
  let w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
  for (const [lon, lat] of ring) {
    if (lon < w) w = lon;
    if (lon > e) e = lon;
    if (lat < s) s = lat;
    if (lat > n) n = lat;
  }
  return {
    id: `preset-${preset.key}-${Date.now()}`,
    mode: "polygon",
    coords: ring,
    bbox: [w, s, e, n],
    area_km2: polygonAreaKm2(ring),
    presetKey: preset.key,
    presetName: preset.name,
  };
}
